import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import AiChat from "../components/AiChat";
import Booking from "../components/Booking";
import Pricing from "../components/Pricing";
import Tips from "../components/Tips";
import Merch from "../components/Merch";
import Footer from "../components/Footer";

export default function Home() {
  const [selectedService, setSelectedService] = useState("");

  useEffect(() => {
    // Handle hash navigation on load
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    }
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain">
      <Navbar />
      <Hero onCta={scrollTo} />
      <Services
        onBook={(id) => {
          setSelectedService(id);
          scrollTo("booking");
        }}
      />
      <AiChat />
      <Booking
        preselectServiceId={selectedService}
        onSelected={() => setSelectedService("")}
      />
      <Pricing />
      <Tips />
      <Merch />
      <Footer />
    </div>
  );
}
